import PersonIcon from '@mui/icons-material/Person';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';

export const services = [
    {
        name: 'services',
        icon: PersonIcon,
        title: "7000 Happy Customer",
        body: "dolor sit amet consectetur adipisicing elit. Eum enim et quisquam consequatur nisi officiis Eum enim"
    },
    {
        name: 'services',
        icon: MessageOutlinedIcon,
        title: "24/7 Support",
        body: "dolor sit amet consectetur adipisicing elit. Eum enim et quisquam consequatur nisi officiis Eum enim"
    },
    {
        name: 'services',
        icon: SendOutlinedIcon,
        title: "Global Community",
        body: "dolor sit amet consectetur adipisicing elit. Eum enim et quisquam consequatur nisi officiis Eum enim"
    }
]